import { render } from "./High2.vue?vue&type=template&id=e5faedf2&ts=true"
import script from "./High2.vue?vue&type=script&lang=ts"
export * from "./High2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/High2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5faedf2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5faedf2', __exports__)) {
    api.reload('e5faedf2', __exports__)
  }
  
  module.hot.accept("./High2.vue?vue&type=template&id=e5faedf2&ts=true", () => {
    api.rerender('e5faedf2', render)
  })

}


export default __exports__